export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'și',
'_.loadingSpinnerText': 'Vă rugăm să așteptați...',
'pageTimerMax.text': 'Veți fi redirecționat automat către pagina următoare după expirarea timpului.',
'pageTimerMax.timeLeft': 'Timp rămas',
'pageTimerMin.text': 'Nu există nicio opțiune pentru a trece mai departe înainte de expirarea timpului.',
'pageTimerMin.timeLeft': 'Timp rămas',
'pageTimerMin.allowNext': 'Puteți merge mai departe',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Doresc să primesc buletinul informativ',
'survey.registerForm.label.regulations': 'Accept politica de confidențialitate și termenii și condițiile',
'survey.registerForm.button.register': 'Înregistrare',
'survey.registerForm.registered': 'Vă mulțumim pentru înregistrare. Un e-mail cu un link de activare a fost trimis în căsuța dvs. de e-mail.',
'survey.registerForm.cardHeader': 'Înregistrați-vă și primiți puncte!',
'survey.registerForm.cardBody': 'Pentru completarea sondajului ați primit',
'survey.registerForm.cardBody2': 'Punctele vă vor fi creditate după ce veți înregistra un cont pe swpanel.co.uk. Introduceți adresa dvs. de e-mail și înregistrați-vă un cont la swpanel.ro',
'survey.notProperDevice': 'Din păcate, nu puteți completa sondajul pe acest dispozitiv.',
'survey.properDevices': 'Sondajul poate fi accesat de pe următoarele dispozitive:',
'survey.device-phone': 'smartphone',
'survey.device-tablet': 'tabletă',
'survey.device-desktop': 'computer / laptop',
'nextSurveys.header.seeAlso': 'Vedeți și alte sondaje',
'nextSurveys.button.fill': 'Completați',
'question.noContent': 'Conținutul întrebării lipsește',
'question.input.placeholder.typeYourAnswer': 'Introduceți răspunsul dvs.',

'question.conjoint.go': 'Faceți clic pe butonul "Următorul"',
'question.matrix.carousel.go': 'Faceți clic pe butonul "Următorul"',
'question.carousel.prevBtn': 'Declarația anterioară',
'question.carousel.nextBtn': 'Enunțul următor',

'question.open.email.inputPlaceholder': 'Introduceți adresa de e-mail',
'question.open.email.emailVerify.sendCode': 'Trimiteți codul de verificare',
'question.open.email.emailVerify.enderCode': 'Introduceți codul pe care l-ați primit',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Introduceți codul',
'question.open.email.emailVerify.confirm': 'Confirmați',
'question.open.email.emailVerify.codeIncorrect': 'Codul pe care l-ați introdus este incorect',
'question.open.email.emailVerify.codeCorrect': 'Adresa de e-mail a fost verificată corect',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Întreruperea încărcării',
'footer.buttonPrev.text': 'Înapoi',
'footer.buttonClear.text': 'Ștergeți',
'footer.buttonNext.text': 'Următorul',
'footer.buttonEnd.text': 'Finalizați',
'footer.buttonStart.text': 'Începeți sondajul',
'question.matrix.nextStatement': 'Enunțul următor',
'question.matrix.previousStatement': 'Declarația anterioară',
};
